import { apiClient } from './apiClient';

export type RecurrenceFrequency = {
  id: number;
  name: string;
};

export function getRecurrenceFrequencies(): Promise<RecurrenceFrequency[]> {
  return apiClient.get('/recurrence-settings/frequencies', {});
}

export type RecurrenceGenerateBefore = {
  id: number;
  name: string;
};

export function getRecurrenceGenerateBefores(): Promise<
  RecurrenceGenerateBefore[]
> {
  return apiClient.get('/recurrence-settings/generate-befores', {});
}

export type BasedOn = {
  id: number;
  name: string;
};

export function getBasedOns(): Promise<BasedOn[]> {
  return apiClient.get('/recurrence-settings/based-ons', {});
}

export type RecurrenceSettingPayload = {
  recurrenceFrequencyId: number;
  basedOnId: number;
  firstMonth?: number;
  secondMonth?: number;
  thirdMonth?: number;
  fourthMonth?: number;
  dayOfMonth?: number;
  dueMonth?: number;
  dueDay?: number;
  extendMonth?: number;
  generateTasksDays: number;
  generateBeforeId: number;
  allowOverridingMonths?: boolean;
};

const recurrenceBasePath = (templateId?: number) =>
  templateId
    ? `/templates/${templateId}/recurrence-settings`
    : '/recurrence-settings';

export function validateCreateRecurrenceSetting(
  body: RecurrenceSettingPayload,
  templateId?: number,
  filesUnder?: number,
  templateTypeId?: number,
  filingTypeId?: number,
  filingStatusId?: number
): Promise<unknown> {
  return apiClient.post(
    `${recurrenceBasePath(templateId)}/validate-recurrence-settings`,
    {
      ...(filesUnder ? { filesUnder } : {}),
      ...(templateTypeId ? { templateTypeId } : {}),
      ...(filingTypeId ? { filingTypeId } : {}),
      ...(filingStatusId ? { filingStatusId } : {}),
      recurrenceSettings: [body],
    }
  );
}

export function validateUpdateRecurrenceSetting(
  recurrenceSettingId: number,
  body: RecurrenceSettingPayload,
  templateTypeId: number,
  templateId?: number,
  filesUnder?: number,
  filingTypeId?: number,
  filingStatusId?: number
): Promise<unknown> {
  return apiClient.post(
    `${recurrenceBasePath(templateId)}/validate-recurrence-settings`,
    {
      ...(filesUnder ? { filesUnder } : {}),
      ...(filingTypeId ? { filingTypeId } : {}),
      ...(filingStatusId ? { filingStatusId } : {}),
      recurrenceSettings: [{ id: recurrenceSettingId, ...body }],
      templateTypeId,
    }
  );
}

export function validateDeleteRecurrenceSetting(
  recurrenceSettingId: number,
  templateId?: number
): Promise<unknown> {
  return apiClient.post(
    `${recurrenceBasePath(templateId)}/${recurrenceSettingId}/validate-delete`,
    {}
  );
}
